export default {
  paragraph1: {
    id: 'dashboard_orderline_content_express_replacement_on_going_paragraph1',
    defaultMessage:
      'You ordered your Express Replacement on {date, date, long}.',
  },
  paragraph2: {
    id: 'dashboard_orderline_content_express_replacement_on_going_paragraph2',
    defaultMessage:
      "You have until {date, date, long} to send the original device back after receiving your replacement. If you don't make the return or if it has additional damage, you'll be charged the same amount as your original device.",
  },
  faqLinkLabel: {
    id: 'dashboard_orderline_content_express_replacement_on_going_faq_link_label',
    defaultMessage: 'See how Express Replacement works',
  },
}
